import { ucApi } from '.';
import { AuthLoginParams } from './uc';
import { ResponseData } from '@/utils/axios';

/**
 * Authentication service for login operations
 * @param params Login parameters
 * @returns API response
 */
export const authLogin = (params: AuthLoginParams): Promise<ResponseData> => {
  return ucApi.auth.login(params);
}; 